var _g, _path, _g2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleAmlImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 231,
    viewBox: "0 0 367 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5340_62239)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 105.75,
    x2: 23.6348,
    y2: 105.75,
    stroke: "#EFF1F3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 209.75,
    x2: 23.6348,
    y2: 209.75,
    stroke: "#EFF1F3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342,
    y1: 157.75,
    x2: 25.6348,
    y2: 157.75,
    stroke: "#EFF1F3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6328,
    y: 69,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6328,
    y: 69,
    width: 112,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6328,
    y: 121,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6328,
    y: 121,
    width: 82,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6328,
    y: 173,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6328,
    y: 173,
    width: 169,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6328,
    y: 227,
    width: 32,
    height: 20,
    rx: 10,
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6328,
    y: 227,
    width: 82,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 46.75H346.25V232.25H0.75V70C0.75 57.1594 11.1594 46.75 24 46.75Z",
    stroke: "#D9E5F8",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5340_62239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 15,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#6FCBD4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 15,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.997 29.166C304.518 29.166 295.164 38.5202 295.164 49.9993C295.164 61.4785 304.518 70.8327 315.997 70.8327C327.477 70.8327 336.831 61.4785 336.831 49.9993C336.831 38.5202 327.477 29.166 315.997 29.166ZM325.956 45.2077L314.143 57.0202C313.852 57.3118 313.456 57.4785 313.039 57.4785C312.622 57.4785 312.227 57.3118 311.935 57.0202L306.039 51.1243C305.435 50.5202 305.435 49.5202 306.039 48.916C306.643 48.3118 307.643 48.3118 308.247 48.916L313.039 53.7077L323.747 42.9993C324.352 42.3952 325.352 42.3952 325.956 42.9993C326.56 43.6035 326.56 44.5827 325.956 45.2077Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 50L153 50",
    stroke: "#E8E8E8",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205 50L290 50",
    stroke: "#E8E8E8",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5340_62239",
    x: 265,
    y: 0.5,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0 0.675 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5340_62239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5340_62239",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5340_62239"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70C0 56.7452 10.7452 46 24 46H347V233H0V70Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleAmlImg);
export default __webpack_public_path__ + "static/media/single-aml-img.fde635edb0c6e82b4bd80df4da6236b8.svg";
export { ForwardRef as ReactComponent };